import { Sparkles, ArrowRight } from "lucide-react";
import { ENAGA_PHOTOS } from "@/lib/localMedia";
import { useDonation } from "@/context/DonationContext";

export default function TransformandoVidas() {
  const { openModal } = useDonation();
  return (
    <section
      id="transformando-vidas"
      data-testid="transformando-vidas-section"
      className="section-pad bg-white relative overflow-hidden"
    >
      <div className="container-ga relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-5 space-y-4 order-2 lg:order-1">
            <div className="relative rounded-3xl overflow-hidden aspect-[4/5] shadow-lg">
              <img
                src={ENAGA_PHOTOS.acolhimento}
                alt="Equipe e crianças do Instituto em ambiente acolhedor"
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="relative rounded-3xl overflow-hidden aspect-square shadow-md">
                <img
                  src={ENAGA_PHOTOS.oficina}
                  alt="Oficina criativa do Instituto ENAGA"
                  loading="lazy"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="relative rounded-3xl overflow-hidden aspect-square shadow-md">
                <img
                  src={ENAGA_PHOTOS.atendimento}
                  alt="Atendimento individual do Instituto"
                  loading="lazy"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 order-1 lg:order-2">
            <div className="pill border-ga-emerald/30 text-ga-emerald_deep bg-ga-emerald/10 mb-6" data-testid="transformando-pill">
              <Sparkles className="w-3.5 h-3.5" /> Transformando vidas
            </div>
            <h2 className="font-display font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-ga-ink">
              Cada criança que chega,{" "}
              <span className="gradient-text-ga">sai diferente</span>.
            </h2>

            <blockquote className="mt-8 text-xl sm:text-2xl text-ga-ink leading-relaxed italic border-l-4 border-ga-amber pl-6">
              O Instituto GA+ nasceu para transformar vidas. Através do
              esporte, do cuidado com a saúde e do apoio espiritual,
              impactamos jovens, crianças e famílias todos os dias.
            </blockquote>

            <p className="mt-6 text-ga-ink/70 text-base sm:text-lg leading-relaxed">
              Acreditamos que uma vida transformada transforma um lar, e um
              lar transformado transforma uma comunidade. É a partir dessa
              convicção que construímos cada projeto, cada atendimento, cada
              oração.
            </p>

            <button
              type="button"
              onClick={() => openModal("transformando-vidas")}
              data-testid="transformando-cta"
              className="mt-8 btn-primary"
            >
              Fazer parte dessa história
              <ArrowRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
